import {
    wymsFetch,
    getParams,
    wymsFetchNoProcess,
    systemFetch,
    proFetch,
    newcard,
    wxcepClient1Fetch,
} from '@/utils/fetch';


// 查询学校列表
export function querySchoolList(args) {
    const params = getParams(true, args);
    if (args.bussinessNumber !== undefined) {
        params.append('bussinessNumber', args.bussinessNumber);
    } else {
        params.append('subBranchCode', args.subBranchCode);
    }
    params.append('isDelete', args.isDelete);
    params.append('orgAreaCode', args.orgAreaCode);
    params.append('type', args.type);
    params.append('searchVal', args.searchVal);
    params.append('liableNames', args.liableNames);
    params.append('clientType', args.clientType);
    params.append('interfaceState', args.interfaceState);

    return wymsFetch({
        url: 'school/querySchoolList',
        method: 'GET',
        params
    });
}

// 删除学校
export function deleteSchool(args) {
    const params = getParams();
    params.append('schoolIds', args.schoolIds);

    return wymsFetch({
        url: 'school/deleteSchool',
        method: 'GET',
        params
    });
}

// 禁用、启用学校
export function updateState(args) {
    const params = getParams();
    params.append('schoolIds', args.schoolIds);
    params.append('usedState', args.usedState);

    return wymsFetch({
        url: 'school/updateState',
        method: 'GET',
        params
    });
}

// 新增学校
export function insertSchool(args) {
    const params = getParams();
    params.append('bussinessNumber', args.bussinessNumber);
    params.append('managerEmail', args.managerEmail);
    params.append('managerMobile', args.managerMobile);
    params.append('managerName', args.managerName);
    params.append('clientType', args.clientType);
    params.append('name', args.name);
    params.append('squareLogoUrl', args.squareLogoUrl);
    params.append('roundLogoUrl', args.roundLogoUrl);
    params.append('type', args.type);
    params.append('areaCode', args.areaCode);
    params.append('orgAreaCode', args.orgAreaCode);
    params.append('orgAreaName', args.orgAreaName);

    return wymsFetch({
        url: 'school/insertSchool',
        method: 'POST',
        data: params
    });
}

// 查询学校详情
export function querySchoolDetail(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/querySchoolDetail',
        method: 'GET',
        params
    });
}

// 查询授权code
export function queryAuthCode(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/queryAuthCode',
        method: 'GET',
        params
    });
}

// 编辑学校
export function updateSchool(args) {
    const params = getParams();
    params.append('bussinessNumber', args.bussinessNumber);
    params.append('domainName', args.domainName);
    params.append('fullName', args.fullName);
    params.append('groupName', args.groupName);
    params.append('groupSchoolId', args.groupSchoolId);
    params.append('id', args.id);
    params.append('isExternalContact', args.isExternalContact);
    params.append('isNewMobile', args.isNewMobile);
    params.append('isPublic', args.isPublic);
    params.append('isTxlx', args.isTxlx);
    params.append('managerEmail', args.managerEmail);
    params.append('managerMobile', args.managerMobile);
    params.append('managerName', args.managerName);
    params.append('name', args.name);
    params.append('newSchoolSecret', args.newSchoolSecret);
    params.append('orgAreaCode', args.orgAreaCode);
    params.append('orgAreaName', args.orgAreaName);
    params.append('orgCode', args.orgCode);
    params.append('roundLogoUrl', args.roundLogoUrl);
    params.append('schoolType', args.schoolType);
    params.append('simpleName', args.simpleName);
    params.append('squareLogoUrl', args.squareLogoUrl);
    params.append('subscribeQrcode', args.subscribeQrcode);
    params.append('syncForWx', args.syncForWx);
    params.append('useNew', args.useNew);
    params.append('wxqrcode', args.wxqrcode);
    params.append('areaCode', args.areaCode);
    params.append('thirdSchoolId', args.thirdSchoolId);
    params.append('platformSync', args.platformSync);
    params.append('addressBookPerm', args.addressBookPerm);
    params.append('ssoDomainName', args.ssoDomainName);
    params.append('orderRange', args.orderRange);
    params.append('address', args.address);
    params.append('orderOrgAreaCode', args.orderOrgAreaCode);
    params.append('orderOrgAreaName', args.orderOrgAreaName);
    params.append('tencentSchoolVersion', args.tencentSchoolVersion);
    params.append('suiteType', args.suiteType);
    params.append('isPushdata', args.isPushdata);
    params.append('subBranchCode', args.subBranchCode);
    params.append('guestSourceCode', args.guestSourceCode);
    params.append('subBranch', args.subBranch);
    params.append('guestSource', args.guestSource);
    params.append('joinDate', args.joinDate);
    params.append('clientType', args.clientType);
    params.append('syncForWxAddress', args.syncForWxAddress);
    params.append('syncForWxAddressSchool', args.syncForWxAddressSchool);

    if (args.originalCorpId) {
        params.append('originalCorpId', args.originalCorpId);
    }
    return wymsFetch({
        url: 'school/updateSchool',
        method: 'GET',
        params
    });
}

// 查询总校
export function queryGroupSchoolList(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/queryGroupSchoolList',
        method: 'GET',
        params
    });
}

// 初始化新生年级
export function initNewGradeAndClass(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/initNewGradeAndClass',
        method: 'GET',
        params
    });
}
//取消农行同步
export function updateSysnCancel(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return systemFetch({
        url: 'abcSmartCampus/cancelSchoolData',
        method: 'GET',
        timeout: 300000,
        params
    });
}
// 批量同步到农行
export function updateSysn(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return systemFetch({
        url: 'abcSmartCampus/syncSchoolData',
        method: 'GET',
        timeout: 300000,
        params
    });
}

// 初始化校友部门
export function initSchoolFellowDepart(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/initSchoolFellowDepart',
        method: 'GET',
        params
    });
}

// 初始化校外用户部门
export function initOutsideSchoolUserDepart(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/initOutsideSchoolUserDepart',
        method: 'GET',
        params
    });
}

// 初始化部门Code
export function initDepartCode(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/initDepartCode',
        method: 'GET',
        params
    });
}

// 批量重置学生密码
export function restNoSetPasswordUser(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/restNoSetPasswordUser',
        method: 'GET',
        params
    });
}

// 存量教职工数据处理
export function updatePlatformTeacher(args) {
    const params = getParams();
    params.append('orgCode', args.orgCode);
    params.append('postCode', args.postCode);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'platformHistory/updatePlatformTeacher',
        method: 'GET',
        params
    });
}

// 存量教师部门
export function updatePlatformOrganization(args) {
    const params = getParams();
    params.append('orgCode', args.orgCode);
    params.append('postCode', args.postCode);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'platformHistory/updatePlatformOrganization',
        method: 'GET',
        params
    });
}

// 删除学校应用角色
export function deleteSchoolModuleRole(args) {

    return wymsFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'schoolModuleRole/deleteSchoolModuleRole',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 查询学校应用角色列表
export function queryModuleRolePermissionList(args) {
    const params = getParams(true, args);
    params.append('moduleName', args.moduleName);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModuleRole/queryModuleRolePermissionList',
        method: 'GET',
        params
    });
}

// 查询学校角色列表
export function querySchoolRoleList(args) {
    const params = getParams(true, args);
    params.append('rolename', args.rolename);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolRole/querySchoolRoleList',
        method: 'GET',
        params
    });
}

// 查询学校角色详情
export function querySchoolRoleDetail(args) {
    const params = getParams();
    params.append('roleId', args.roleId);

    return wymsFetch({
        url: 'schoolRole/querySchoolRoleDetail',
        method: 'GET',
        params
    });
}

// 编辑学校角色
export function updateSchoolRole(args) {
    const params = getParams();
    params.append('description', args.description);
    params.append('id', args.id);
    params.append('isChoose', args.isChoose);
    params.append('name', args.name);
    params.append('schoolId', args.schoolId);
    params.append('ynDelete', args.ynDelete);

    return wymsFetch({
        url: 'schoolRole/updateSchoolRole',
        method: 'POST',
        data: params
    });
}

//查询学校应用列表
export function queryModulesBySchoolId(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModuleRole/queryModulesBySchoolId',
        method: 'GET',
        params
    });
}

// 查询学校角色列表
export function queryRoleListBySchoolId(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModuleRole/queryRoleListBySchoolId',
        method: 'GET',
        params
    });
}

// 查询应用角色权限
export function queryByModuleIdAndConstantId(args) {
    const params = getParams();
    params.append('constantId', args.constantId);
    params.append('moduleId', args.moduleId);

    return wymsFetch({
        url: 'schoolModuleRole/queryByModuleIdAndConstantId',
        method: 'GET',
        params
    });
}

// 编辑学校应用角色权限
export function updateModuleRolePermission(args) {
    const params = getParams();
    params.append('perList', args.perList);
    params.append('moduleId', args.moduleId);
    params.append('roleId', args.roleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModuleRole/updateModuleRolePermission',
        method: 'GET',
        params
    });
}

// 新增学校应用角色
export function insertModuleRole(args) {
    const params = getParams();
    params.append('perList', args.perList);
    params.append('moduleId', args.moduleId);
    params.append('roleName', args.roleName);
    params.append('schoolId', args.schoolId);
    if (args.constantId) {
        params.append('constantId', args.constantId);
    }

    return wymsFetch({
        url: 'schoolModuleRole/insertModuleRole',
        method: 'GET',
        params
    });
}

// 查询学校已安装列表
export function queryPerBySchoolIdAndConstantId(args) {
    const params = getParams();
    params.append('constantId', args.constantId);
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModuleRole/queryPerBySchoolIdAndConstantId',
        method: 'GET',
        params
    });
}

//查询角色用户列表

export function queryRoleUserList(args) {
    const params = getParams(true, args);
    params.append('roleId', args.roleId);
    params.append('schoolId', args.schoolId);
    params.append('userName', args.userName);

    return wymsFetch({
        url: 'schoolRole/queryRoleUserList',
        method: 'GET',
        params
    });
}

// 删除角色用户
export function deleteRoleUser(args) {
    const params = getParams(true, args);
    params.append('roleId', args.roleId);
    params.append('userIds', args.userIds);

    return wymsFetch({
        url: 'schoolRole/deleteRoleUser',
        method: 'POST',
        data: params
    });
}

// 新增角色用户
export function insertRoleUser(args) {
    const params = getParams();
    params.append('roleId', args.roleId);
    params.append('userIds', args.userIds);

    return wymsFetch({
        url: 'schoolRole/insertRoleUser',
        method: 'POST',
        data: params
    });
}

// 查询学校模块列表
export function querySchoolModuleList(args) {
    const params = getParams();
    params.append('isIntegrate', args.isIntegrate);
    params.append('isOpen', args.isOpen);
    params.append('moduleName', args.moduleName);
    params.append('moduleType', args.moduleType);
    params.append('schoolId', args.schoolId);
    params.append('status', 1);

    return wymsFetch({
        url: 'schoolModule/querySchoolModuleList',
        method: 'GET',
        params
    });
}

// 安装学校应用
export function updateInstallModule(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModule/updateInstallModule',
        method: 'GET',
        params
    });
}

// 安装学校应用
export function updateUninstallModule(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModule/updateUninstallModule',
        method: 'GET',
        params
    });
}

// 查询操作手册维护
export function queryManualByModuleId(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);

    return wymsFetch({
        url: 'schoolModule/queryManualByModuleId',
        method: 'GET',
        params
    });
}

// 查询应用详情
export function queryModuleById(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);

    return wymsFetch({
        url: 'schoolModule/queryModuleById',
        method: 'GET',
        params
    });
}

// 编辑第三方跳转地址
export function updateModuleSchoolByIp(args) {
    const params = getParams();
    params.append('ip', args.ip);
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModule/updateModuleSchoolByIp',
        method: 'GET',
        params
    });
}

// 编辑第三方跳转地址
export function updateModuleSchoolByPcUrl(args) {
    const params = getParams();
    params.append('pcUrl', args.pcUrl);
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModule/updateModuleSchoolByPcUrl',
        method: 'GET',
        params
    });
}

// 编辑第三方跳转地址
export function updateModuleSchoolByMobileUrl(args) {
    const params = getParams();
    params.append('mobileUrl', args.mobileUrl);
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModule/updateModuleSchoolByMobileUrl',
        method: 'GET',
        params
    });
}

// 查询集成应用使用说明

export function queryIntegrateDetail(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModule/queryIntegrateDetail',
        method: 'GET',
        params
    });
}

// 升年级操作
// export function upgrade(args) {
//     const params = getParams();
//     params.append('clearParent', args.clearParent);
//     params.append('clearStudent', args.clearStudent);
//     params.append('continueUpGradeIds', args.continueUpGradeIds);
//     params.append('schoolId', args.schoolId);
//     params.append('upGradeIds', args.upGradeIds);

//     return wymsFetch({
//         url: 'schoolUpgrade/upgrade',
//         method: 'GET',
//         params
//     });
// }
export function upgrade(data) {
    return wymsFetch({
        url: 'schoolUpgrade/upgrade',
        method: 'post',
        timeout: 300000,
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
}

// 查询年级列表
export function queryGradeList(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolUpgrade/queryGradeList',
        method: 'GET',
        params
    });
}
// 查询是否已经升年级
export function queryAlreadyUpgarde(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolUpgrade/queryAlreadyUpgarde',
        method: 'GET',
        params
    });
}
// 查询是否已经升年级
export function queryCanContinueUpgrade(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolUpgrade/queryCanContinueUpgrade',
        method: 'GET',
        params
    });
}
// 查询学校套件列表
export function querySchoolSuiteList(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/querySchoolSuiteList',
        method: 'GET',
        params
    });
}

// 编辑学校负责人
export function updateSchoolLiable(args) {
    const params = getParams();
    params.append('chooseManagerIds', args.chooseManagerIds);
    params.append('custumerManagerIds', args.custumerManagerIds);
    params.append('confirm', args.confirm);
    params.append('externalContact', args.externalContact);
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'school/updateSchoolLiable',
        method: 'GET',
        params
    });
}

// 查询学校负责人列表
export function queryLiableList(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    params.append('type', args.type);

    return wymsFetch({
        url: 'school/queryLiableList',
        method: 'GET',
        params
    });
}

// 审核学校
export function updateCheckSchool(args) {
    const params = getParams();
    params.append('externalContact', args.externalContact);
    params.append('schoolId', args.schoolId);
    params.append('areaCode', args.areaCode);
    params.append('orgAreaCode', args.orgAreaCode);
    params.append('orgAreaName', args.orgAreaName);
    params.append('schoolType', args.schoolType);
    if (args.confirm) {
        params.append('confirm', args.confirm);
    }

    return wymsFetchNoProcess({
        url: 'school/updateCheckSchool',
        method: 'GET',
        params
    });
}
// 查询学校通知二维码
export function querySubscribeQrcode(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'school/querySubscribeQrcode',
        method: 'GET',
        params
    });
}


// 修改学校应用相关配置
export function updateModuleSchool(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);
    if (args.moduleLogo) {
        params.append('moduleLogo', args.moduleLogo);
    }
    if (args.moduleOtherName) {
        params.append('moduleOtherName', args.moduleOtherName);
    }
    if (args.platformMsg) {
        params.append('platformMsg', args.platformMsg);
    }
    if (args.callbackUrl) {
        params.append('callbackUrl', args.callbackUrl);
    }
    if (args.callbackUrlOnOff) {
        params.append('callbackUrlOnOff', args.callbackUrlOnOff);
    }
    if (args.dataRange) {
        params.append('dataRange', args.dataRange);
    }

    return wymsFetch({
        url: 'schoolModule/updateModuleSchool',
        method: 'POST',
        data: params,
    })
}


// 同步学生及家长
export function updateSyncStudentAndParent(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    params.append('gradeCode', args.gradeCode);
    params.append('classCode', args.classCode);
    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncStudentAndParent',
        method: 'GET',
        params
    });
}

// 同步年级班级
export function updateSyncClazz(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncClazz',
        method: 'GET',
        params
    });
}

// 同步用户
export function updateSyncUser(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncUser',
        method: 'GET',
        params
    });
}

// 同步部门
export function updateSyncDepart(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncDepart',
        method: 'GET',
        params
    });
}

// 同步年级
export function updateSyncGrade(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncGrade',
        method: 'GET',
        params
    });
}


// 焦点对接  班主任同步
export function updateSyncHeadermaster(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncHeadermaster',
        method: 'GET',
        params
    });
}
// 焦点对接  科目同步
export function updateSyncSubject(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncSubject',
        method: 'GET',
        params
    });
}
// 焦点对接  任课信息同步
export function updateSyncTsSubject(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jiaodian/updateSyncTsSubject',
        method: 'GET',
        params
    });
}

// 焦点对接  任课信息同步
export function updateParentExternalUserId(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'jdianExternaluseridController/updateParentExternalUserId',
        method: 'GET',
        params
    });
}

// 同步全部人脸设备
export function syncAllDevice(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wxcepClient1Fetch({
        url: 'structure/yufan/sync/syncAllDevice',
        method: 'GET',
        params
    });
    }
    export function syncUser(args) {
        const params = getParams();
        params.append('schoolId', args.schoolId);

        return wymsFetchNoProcess({
            url: 'keda/syncUser',
            method: 'GET',
            params
        });
    }
    export function syncDept(args) {
        const params = getParams();
        params.append('schoolId', args.schoolId);

        return wymsFetchNoProcess({
            url: 'keda/syncDept',
            method: 'GET',
            params
        });
    }
export function syncAllUser(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wxcepClient1Fetch({
        url: 'structure/yufan/sync/syncAllUser',
        method: 'GET',
        params
    });
}
export function syncAllFace(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wxcepClient1Fetch({
        url: 'structure/yufan/sync/syncAllFace',
        method: 'GET',
        params
    });
}
export function syncAllAuthDevice(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wxcepClient1Fetch({
        url: 'structure/yufan/sync/syncAllAuthDevice',
        method: 'GET',
        params
    });
}
export function syncOneAuthDevice(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wxcepClient1Fetch({
        url: 'structure/yufan/sync/syncOneAuthDevice',
        method: 'GET',
        params
    });
}

// 初始化政务老师数据
export function syncTeacherFromEdu(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'school/syncTeacherFromEdu',
        method: 'GET',
        params,
    })
}

// 海康同步学生家长数据
export function haikangInitStutentAndParent(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'haikang/initStutentAndParent',
        method: 'GET',
        params,
    })
}

// 海康同步教师数据
export function haikangInitTeacher(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'haikang/initTeacher',
        method: 'GET',
        params,
    })
}
// 海康同步教师部门
export function haikangInitDepart(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'haikang/initDepart',
        method: 'GET',
        params,
    })
}
// 海康同步班级
export function haikangInitClass(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'haikang/initClass',
        method: 'GET',
        params,
    })
}
// 海康同步学生数据
export function haikangInitStutent(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    params.append('targetClassCode', args.targetClassCode);
    params.append('targetGradeCode', args.targetGradeCode);
    return wymsFetchNoProcess({
        url: 'haikang/initStudent',
        method: 'GET',
        params,
    })
}

// 海康同步家长数据
export function haikangInitParent(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
      params.append('targetClassCode', args.targetClassCode);
      params.append('targetGradeCode', args.targetGradeCode);
    return wymsFetchNoProcess({
        url: 'haikang/initParent',
        method: 'GET',
        params,
    })
}
export function haikangInitFace(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: 'haikang/initface',
        method: 'GET',
        params,
    })
}
// 同步组织及用户信息
export function synchSchUserList(args) {
    const params = getParams();
    params.append('company', args.company);
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        baseURL: global.command === 'production' ? 'https://www.zhxiaoyuan.cn/card/' : 'https://www.weixiaojia.net/card/',
        url: 'structure/oneCartoon/synchSchUserList',
        method: 'GET',
        params,
    })
}
// 对比家校通讯录
export function contrastResult(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    params.append('secret', args.secret);

    return wymsFetchNoProcess({
        url: '/userContrast/contrastResult',
        method: 'GET',
        params,
    })
}
// 批量删除
export function constrastBatchDelete(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetchNoProcess({
        url: '/userContrast/batchDelete',
        method: 'GET',
        params,
    })
}
//
export function getUserCount(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: '/wxInterface/getUserCount',
        method: 'GET',
        params,
    })
}
export function createOrder(args) {

    return wymsFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'wxLicense/createOrder',
        method: 'POST',
        data: JSON.stringify(args)
    });
}
export function listOrder(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: '/wxInterface/listOrder',
        method: 'GET',
        params,
    })
}
export function listActiceCode(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    params.append('stautus', args.stautus);
    params.append('type', args.type);
    return wymsFetch({
        url: '/wxInterface/listActiceCode',
        method: 'GET',
        params,
    })
}
export function syncActiveCode(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: '/wxInterface/syncActiveCode',
        method: 'POST',
        data: params,
    })
}
export function setAutoActive(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: '/wxInterface/setAutoActive',
        method: 'GET',
        params,
    })
}
export function deleteOrder(args) {
    const params = getParams();
    params.append('orderCode', args.orderCode);

    return wymsFetch({
        url: '/wxInterface/deleteOrder',
        method: 'GET',
        params,
    })
}
// 清空所有学生数据
export function clearAllStudent(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    return systemFetch({
        url: 'sys/user/clearAllStudent',
        method: 'GET',
        params
    })
}
// 与腾讯智慧校园对接  设置家长微信关注账号
export function updateParentExternalUserIdTx(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    return wymsFetchNoProcess({
        url: '/jdianExternaluseridController/updateParentExternalUserId',
        method: 'GET',
        params
    });
}
// 查询经销商列表全部
export function queryBussinessListAll() {
    return wymsFetch({
        url: '/bussiness/queryBussinessListAll',
        method: 'GET'
    });
}

export function deleteTxlParentAndDepart(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    return wymsFetch({
        url: '/userContrast/deleteTxlParentAndDepart',
        method: 'GET',
        params
    });
}

export function initStudentAndParent(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    return wymsFetch({
        url: '/userContrast/initStudentAndParent',
        method: 'GET',
        params
    });
}

export function initDepart(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    return wymsFetch({
        url: '/userContrast/initDepart',
        method: 'GET',
        params
    });
}

export function batchActiveAccount(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: '/wxInterface/batchActiveAccount',
        method: 'POST',
        data: params,
    })
}

export function activeInfo(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: '/wxInterface/activeInfo',
        method: 'GET',
        params
    })
}

export function preCreateOrder(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: '/wxInterface/preCreateOrder',
        method: 'GET',
        params
    })
}

export function update2StandardGrade(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return systemFetch({
        url: 'sys/depart/update2StandardGrade',
        method: 'GET',
        params
    })
}


//向海康同步卡信息
export function synCardInfoToHaiKang(schoolId, cardType) {
    const params = getParams();
    params.append('schoolId', schoolId);
    params.append('cardType', cardType);
    return newcard({
        url: 'structure/campusCard/synCardInfoToHaiKang',
        method: 'GET',
        params
    });
}


export function myactiveInfo(schoolId) {
    const params = getParams();
    params.append('schoolId', schoolId);
    return wymsFetch({
        url: 'wxLicense/activeInfo',
        method: 'GET',
        params
    })
}

export function mysetAutoActive(schoolId) {
    const params = getParams();
    params.append('schoolId', schoolId);
    return wymsFetch({
        url: 'wxLicense/setAutoActive',
        method: 'post',
        data: params
    })
}

export function syncOrders(schoolId) {
    const params = getParams();
    params.append('schoolId', schoolId);
    return wymsFetch({
        url: 'wxLicense/syncOrders',
        method: 'GET',
        params
    })
}


export function queryOrders(schoolId, orderStatus) {
    const params = getParams();
    params.append('schoolId', schoolId);
    params.append('orderStatus', orderStatus);
    return wymsFetch({
        url: 'wxLicense/queryOrders',
        method: 'GET',
        params
    })
}
export function syncUserActiveInfo(schoolId) {
    const params = getParams();
    params.append('schoolId', schoolId);
    return wymsFetch({
        url: 'wxLicense/syncUserActiveInfo',
        method: 'post',
        data: params
    })
}

export function getActiveInfoByUser(args) {
    const params = getParams();
    params.append('activeStatus', args.activeStatus);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('schoolId', args.schoolId);
    params.append('userName', args.userName);
    if (args.isExternalContact) {
        params.append('userType', args.userType);
    }
    return wymsFetch({
        url: 'wxLicense/getActiveInfoByUser',
        method: 'get',
        params,
    })
}
// 批量操作-2. 查看结果
export function batchOpnResult(importMarkId) {
    const params = getParams();
    params.append('importMarkId', importMarkId);
    return wymsFetch({
        url: 'schoolUser/batchOpnResult',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/schoolManage.js